import { Component, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { GoogleMapApiService } from 'src/app/shared/googlemap/GoogleMapApiService';
import { BookNowService } from 'src/app/shared/service/book-now/book-now.service';
import { BannerType, ImageBannerComponent } from 'src/app/shared/widgets/image-banner/image-banner.component';
import { CdnPipe } from "../../../shared/pipe/cdn.pipe";
import { TranslocoModule } from "@ngneat/transloco";
import { RatingDecimalPipe } from "../../../shared/utils/rating-decimal-pipe";
import { CurrencyConverterPipe } from "../../../shared/currency/currency-converter.pipe";
import { AsyncPipe } from "@angular/common";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { ShopRecommendation } from "../models/shop-recommendation";
import { AnalyticsEventCategory, sendEvent } from "../../../shared/analytics/analytics";

@Component({
    selector: 'app-chat-featured-shop',
    templateUrl: './chat-featured-shop.component.html',
    styleUrls: ['./chat-featured-shop.component.scss'],
    imports: [
        CdnPipe,
        TranslocoModule,
        RatingDecimalPipe,
        CurrencyConverterPipe,
        ImageBannerComponent,
        AsyncPipe,
        NgbTooltip,
        RouterLink,
    ]
})

export class ChatFeaturedShopComponent implements OnInit {
  @Input() shop!: ShopRecommendation;

  bannerType: BannerType = BannerType.None;

  constructor(private googleMapApiService: GoogleMapApiService,
              public bookNowService: BookNowService) {
  }

  ngOnInit(): void {
    this.refreshGooglePlaceRating();
    this.refreshBannerType();
  }

  refreshBannerType() {
    if (this.shop.tags?.some((tag) => tag.toLowerCase() === 'michelin')) {
      this.bannerType = BannerType.Michelin;
    } else if (this.shop.rating && this.shop.rating >= 4.2) {
      this.bannerType = BannerType.TopRated;
    }
  }

  refreshGooglePlaceRating() {
    let placeId = this.shop.googlePlaceId;
    if (!placeId) return;

    this.googleMapApiService.getPlaceDetails(placeId).subscribe((result) => {
      if (result) {
        this.shop.rating = result.rating;
        this.refreshBannerType();
      }
    });
  }

  sendRecommendationClickEvent() {
    sendEvent(AnalyticsEventCategory.CHATBOT_RECOMMENDATION_CLICK, this.shop?.shopNumber)
  }

}
